import { render, staticRenderFns } from "./exportcn.vue?vue&type=template&id=88fd8f2c&"
import script from "./exportcn.vue?vue&type=script&lang=js&"
export * from "./exportcn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports